<template>
    <div class="spread-result">
        <span v-for="(card, slug, index) in result" :key="index">
            <span class="result-chunk" :class="{'--visible': card != null}">            
                <span>{{staticText[slug]}}</span>
                <span v-if="card != null">{{card[slug]}}</span>
                <span v-if="slug == 'synthese'">.</span>
            </span>
        </span>
    </div>
</template>

<script>
    export default {

        data () {return {
            result: {
                pour: null,
                contre: null,
                vibration: null,
                direction: null,
                synthese: null
            },
            staticText: {
                pour: 'You feel ',
                contre: ' but you ',
                vibration: ' and you are ',
                direction: ' This could lead you to ',
                synthese: ' To sum up you seem to be '
            }
        }},

        methods: {
            reset () {
                this.result = {
                    pour: null,
                    contre: null,
                    vibration: null,
                    direction: null,
                    synthese: null
                }
            },

            set (slug, card) {
                this.result[slug] = card    
            },
        }
    }
</script>